
 
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ClientListComponent } from './view/client-list/client-list.component';
import { StaffService } from './service/staff.service';
import { PackagesponsorService } from './service/package.service';
import { SecteurService } from './service/secteur.service';
import { FactureService } from './service/facture.service';
import { JwtInterceptor } from './service/jwt.interceptor.service';


import { StandService } from './service/stand.service';
import { ContactService } from './service/contact.service';
import { ProspectService } from './service/prospect.service';
import { CreateClientComponent } from './view/client-list/create-client/create-client.component';
import { NewExhibitorComponent } from './view/client-list/new-exhibitor/new-exhibitor.component';
import { MaterialModule } from './sharedmodule/material.module';
import { PersonalFormComponent } from './view/forms/personal-form/personal-form.component';
import { ContactFormComponent } from './view/forms/contact-form/contact-form.component';
import { ResultFormComponent } from './view/forms/result-form/result-form.component';
import { StandProjetComponent } from './view/forms/lists/stand-projet/stand-projet.component';
import { StandsExposantComponent } from './view/forms/stands-exposant/stands-exposant.component';
import { PanierFormComponent } from './view/forms/panier-form/panier-form.component';
import { FacturationFormComponent } from './view/forms/facturation-form/facturation-form.component';
import { AddressFormComponent } from './view/forms/address-form/address-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {SidebarModule} from 'primeng/sidebar';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ExhibitorService } from './service/exhibitor.service';
import { HttpModule } from '@angular/http';
import { ProjetService } from './service/projet.service';
import { ExhibitorDialogComponent } from './shared/dialogs/exhibitor-dialog/exhibitor-dialog.component';
import { ConfirmedDialogComponent } from './shared/dialogs';
import { PersonelClientComponent } from './shared/formsClient/personel-client/personel-client.component';
import { ContactsClientComponent } from './shared/formsClient/contacts-client/contacts-client.component';
import { FacturationClientComponent } from './shared/formsClient/facturation-client/facturation-client.component';
import { StandsClientComponent } from './shared/formsClient/stands-client/stands-client.component';
import { OptionsExposantsComponent } from './shared/formsClient/options-exposants/options-exposants.component';
import { OtherOptionsComponent } from './shared/formsClient/other-options/other-options.component';
import { DetailStandClientComponent } from './view/client-list/detail-stand-client/detail-stand-client.component';
import { ContactsProspectComponent } from './view/forms/lists/contacts-prospect/contacts-prospect.component';
import { DelegateFormComponent } from './view/forms/delegate-form/delegate-form.component';
import { ContactsClientDialogComponent } from './shared/dialogs/contacts-client-dialog/contacts-client-dialog.component';
import { DelegateService } from './service/delegate.service';
import { TitreService } from './service/titre.service';
import { NgxBreadcrumbsModule } from 'ng8-breadcrumbs';
import { AngularFittextModule } from 'angular-fittext';
import { BreadcrumbModule } from 'angular-crumbs';
import {DialogModule} from 'primeng/dialog';
import { ComposeMailComponent } from './view/email/include/compose-mail/compose-mail.component';
 
import {ConfirmationService, MessageService } from 'primeng/api';
import { TagInputModule } from 'ngx-chips';
import { CKEditorModule } from 'ng2-ckeditor';
import { ContactListComponent } from './view/forms/lists/contact-list/contact-list.component';
import {TableModule} from 'primeng/table';
import { MailsService } from './service/mails.service';
import { TestViewComponent } from './view/test-view/test-view.component';
import { FloorComponent } from './view/floor-plan/floor.component';
 
import { FloorService } from './service/floor.service';
import {ToastModule} from 'primeng/toast';
import { ReportingComponent } from './view/reporting/reporting.component';
import { DelegateReportingComponent } from './view/reporting/delegate-reporting/delegate-reporting.component';
import {ToggleButtonModule} from 'primeng/togglebutton';
import { ContenufacturesComponent } from './view/forms/contenufactures/contenufactures.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from 'src/environments/environment';
import { SpeakerComponent } from './view/reporting/speaker/speaker.component';
import { SpeakerService } from './service/speaker.service';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { SonatrachComponent } from './view/reporting/sonatrach/sonatrach.component';
import { SonatrachService } from './service/firebase/sonatrach.service';
import { EtatSortieComponent } from './view/etat-sortie/etat-sortie.component';
import { InvitationVisaService } from './service/invitation.visa.service';
import { BadgesComponent } from './view/badges/badges.component';
import { DashboardComponent } from './view/dashboard/dashboard.component';
import { InviationsvisaComponent } from './shared/formsClient/inviationsvisa/inviationsvisa.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import { LogistiqueComponent } from './view/logistique/logistique.component';
import { MaterielComponent } from './view/logistique/materiel/materiel.component';
import { FacturedetailService } from './service/facture.detail.service';
import { PubliciteComponent } from './view/logistique/publicite/publicite.component';
import { StandsComponent } from './view/logistique/stands/stands.component';
import { BadgesVisiteurComponent } from './view/badges/badges-visiteur/badges-visiteur.component';
import { VisiteurServiceService } from './service/visiteur.service';
import { BadgesExposantComponent } from './view/badges/badges-exposant/badges-exposant.component';
import { BadgeServiceService } from './service/badge.service';
import { StaffComponent } from './view/admin/staff/staff.component';
import { AdminComponent } from './view/admin/admin.component';
import {CheckboxModule} from 'primeng/checkbox';
import {MultiSelectModule} from 'primeng/multiselect';
import { LoginComponent } from './view/login/login.component';
import { AuthenticationService } from './service/authentication-service.service';
import { ModeleComponent } from './view/admin/modele/modele.component';
import { AdminService } from './service/admin.service';
import { SocieteComponent } from './view/admin/societe/societe.component';
import { DialogUserListsComponent } from './shared/dialogs/dialog-user-lists/dialog-user-lists.component';
import {ListboxModule} from 'primeng/listbox';
import { FactureListComponent } from './view/forms/lists/facture-list/facture-list.component';
import { FactureDialogComponent } from './shared/dialogs/facture-dialog/facture-dialog.component';
import { InvoicesParticipantsComponent } from './view/invoices-participants/invoices-participants.component';
import { EditInvoiceComponent } from './view/invoices-participants/edit-invoice/edit-invoice.component';
import { SelectprodListComponent } from './view/invoices-participants/selectprod-list/selectprod-list.component';
 
import { ListDelagateComponent } from './view/etat-sortie/list-delagate/list-delagate.component';
import { ListeExhibitorsComponent } from './view/etat-sortie/liste-exhibitors/liste-exhibitors.component';
import { ListeSpeakersComponent } from './view/etat-sortie/liste-speakers/liste-speakers.component';
import { ListeSponsorsComponent } from './view/etat-sortie/liste-sponsors/liste-sponsors.component';
import { ListeArchiveeComponent } from './view/etat-sortie/liste-archivee/liste-archivee.component';
import {DropdownModule} from 'primeng/dropdown';
import { NotficationsComponent } from './view/etat-sortie/notfications/notfications.component';
import { ReportingService } from './service/reporting.service';
import { SignalitiqueComponent } from './view/logistique/signalitique/signalitique.component';
import { SignaletiqueService } from './service/signalitique.service';
import { ConstructeursComponent } from './view/logistique/constructeurs/constructeurs.component';
import { HotelsComponent } from './view/logistique/hotels/hotels.component';
import { ClientContructeursComponent } from './view/forms/client-contructeurs/client-contructeurs.component';
import { ClientsProjetComponent } from './view/forms/lists/clients-projet/clients-projet.component';
import { ProduitsComponent } from './view/admin/produits/produits.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import { Hebergement } from './entity/hebergement';
import { LogistiqueService } from './service/logistique.service';
import {CalendarModule} from 'primeng/calendar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { SteeringComponent } from './view/reporting/steering/steering.component';
import {EditorModule} from 'primeng/editor';
import { ChipsModule } from 'primeng';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { ConferenceComponent } from './view/conference/conference.component';
import { ProgrammeComponent } from './view/conference/programme/programme.component';
import { CommonModule } from "@angular/common";
 import {OverlayPanelModule} from 'primeng/overlaypanel';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { PjointsComponent } from './view/admin/pjoints/pjoints.component';
import { PackageSponsorComponent } from './shared/formsClient/package-sponsor/package-sponsor.component';
import { PackageDialogComponent } from './shared/formsClient/package-sponsor/package-dialog/package-dialog.component';
import {StepsModule} from 'primeng/steps';
import { ContactPackageComponent } from './shared/formsClient/package-sponsor/contact-package/contact-package.component';
import {InputTextModule} from 'primeng/inputtext';
import { ClientListDialogComponent } from './view/client-list/client-list-dialog/client-list-dialog.component';
import { NoteClientComponent } from './shared/formsClient/note-client/note-client.component';
import { CountryDialogComponent } from './shared/dialogs/country-dialog/country-dialog.component';
  @NgModule({
  declarations: [
    AppComponent,
    ClientListComponent,
    CreateClientComponent,
    InvoicesParticipantsComponent,
 
    SelectprodListComponent,
    EditInvoiceComponent,
    NewExhibitorComponent,
    PersonalFormComponent,
    ContactFormComponent,
    ResultFormComponent,
    StandProjetComponent,
    StandsExposantComponent,
    PanierFormComponent,
    FacturationFormComponent,
    AddressFormComponent,
    NewExhibitorComponent,
    ExhibitorDialogComponent,
    ConfirmedDialogComponent,
    PersonelClientComponent,
    ContactsClientComponent,
    FacturationClientComponent,
    StandsClientComponent,
    OptionsExposantsComponent,
    OtherOptionsComponent,
    DetailStandClientComponent,
    ContactsProspectComponent,
    DelegateFormComponent,
    ContactsClientDialogComponent,
    ComposeMailComponent,
    ContactListComponent,
    TestViewComponent,
    FloorComponent,
    ReportingComponent,
    DelegateReportingComponent,
    ContenufacturesComponent,
    SpeakerComponent,
    SonatrachComponent,
    EtatSortieComponent,
    BadgesComponent,
    DashboardComponent,
    InviationsvisaComponent,
    LogistiqueComponent,
    MaterielComponent,
    PubliciteComponent,
    StandsComponent,
    BadgesVisiteurComponent,
    BadgesExposantComponent ,
    StaffComponent,
    AdminComponent,
    LoginComponent,
    ModeleComponent,
    SocieteComponent,
    DialogUserListsComponent,
    FactureListComponent,
    FactureDialogComponent,
    ListDelagateComponent,
    ListeExhibitorsComponent,
    ListeSpeakersComponent,
    ListeSponsorsComponent,
    ListeArchiveeComponent,
    NotficationsComponent,
    SignalitiqueComponent,
    ConstructeursComponent,
    HotelsComponent,
    ClientContructeursComponent,
    ClientsProjetComponent,
    ProduitsComponent,
    SteeringComponent,
    ConferenceComponent,
    ProgrammeComponent,
     PjointsComponent,
     PackageSponsorComponent,
     PackageDialogComponent,
     ContactPackageComponent,
     ClientListDialogComponent,
     NoteClientComponent,
     CountryDialogComponent 
  ],
  imports: [
    CommonModule ,
    FormsModule,
    InputTextModule,
    SidebarModule,
    AutoCompleteModule,
    DragDropModule,
    TagInputModule,
     DialogModule,
    ClipboardModule,
    CheckboxModule,
    ListboxModule,
    InputSwitchModule,
    ToastModule,
    ConfirmDialogModule,
    ToggleButtonModule,
    DropdownModule,
    StepsModule,
    AngularFittextModule,
    CalendarModule,
    ProgressSpinnerModule,
    NgxBreadcrumbsModule,
    BreadcrumbModule,
    BrowserAnimationsModule,
 
    AppRoutingModule,
    MaterialModule,
  
    ReactiveFormsModule,
    HttpClientModule,
 
    HttpModule,
 
    ChipsModule,
    CKEditorModule,
    EditorModule,
    TableModule,
    OverlayPanelModule,
    SelectButtonModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule, 
    MultiSelectModule
  ],
  providers: [ProspectService, ProjetService, ContactService, StandService, FactureService,InvitationVisaService,
    StaffService, SecteurService, ExhibitorService,MessageService, DelegateService,SonatrachService,SignaletiqueService,
    ConfirmationService,StaffService,
    SpeakerService,BadgeServiceService,
    TitreService,MailsService,FloorService,
  FacturedetailService,VisiteurServiceService,
  PackagesponsorService,
  LogistiqueService,
  ReportingService,
AuthenticationService,AdminService ,
{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
],
 
  bootstrap: [AppComponent],
  entryComponents: [
    ExhibitorDialogComponent, ConfirmedDialogComponent, ContactsClientDialogComponent,SelectprodListComponent
  ]
})
export class AppModule { }
